import { BUTTON_SIZE, BUTTON_TYPE, DSButton, DSModal } from '@repo/design-system/index'
import { APP_SCREEN_NAME } from '../../../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import useReturnFullUrl from '../../../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_ai_analysis, n_common } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../../modules/vars'
import JobInputModal from '../JobInput/JobInputModal'

const JobAnalysisModal = ({
  isShowAlertPopup,
  showAlertPopup,
  setShowAlertPopup,
  info,
  isShowJobInputPopup,
  showJobInputPopup,
  setShowJobInputPopup,
}) => {
  const router = useAppRouter()
  const getFullUrl = useReturnFullUrl()
  const { t } = useTranslation()
  return (
    <>
      {isShowAlertPopup && (
        <DSModal
          id="TextOnlySMTwoButtonHorizontalPopup"
          isOpen={showAlertPopup}
          setIsOpen={setShowAlertPopup}
          size={'sm'}
        >
          <DSModal.Title>{t(n_ai_analysis.job_seg_popup.title)}</DSModal.Title>
          <DSModal.Content className="mt-[16px]">{t(info.description)}</DSModal.Content>
          <DSModal.ButtonContainer direction="horizontal">
            <DSButton
              size={BUTTON_SIZE.MD}
              type={BUTTON_TYPE.OUTLINE}
              customBgColor={COLORS.WHITE}
              onClick={() => setShowAlertPopup(false)}
            >
              <DSButton.Label>{t(n_common.btn_cancel)}</DSButton.Label>
            </DSButton>
            <DSButton
              size={BUTTON_SIZE.MD}
              onClick={(e) => {
                router.push(info.link, {
                  appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
                  appSendData: {
                    url: getFullUrl(info.webviewLink),
                  },
                })
              }}
            >
              <DSButton.Label>{info.title}</DSButton.Label>
            </DSButton>
          </DSModal.ButtonContainer>
        </DSModal>
      )}
      {isShowJobInputPopup && <JobInputModal showPopup={showJobInputPopup} setShowPopup={setShowJobInputPopup} />}
    </>
  )
}
export default JobAnalysisModal
